import React from "react";
import { Link } from "react-router-dom";
import { Home, Ruler, Building2 } from "lucide-react";
import { formatINR, statusMeta, absUrl } from "@/lib/format";

export default function PropertyCard({ p, index = 0 }) {
  const meta = statusMeta(p.status);
  return (
    <Link
      to={`/properties/${p.slug}`}
      data-testid={`property-card-${p.slug}`}
      className="brutal-card overflow-hidden flex flex-col"
      style={{ animation: `fadeUp 0.5s ${index * 60}ms both` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden border-b-2 border-black bg-[#F3F2EE]">
        <img src={absUrl(p.image)} alt={p.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
        <span className="badge-pill absolute top-3 right-3" style={{ background: meta.bg, color: meta.color }}>{meta.label}</span>
        <span className="badge-pill absolute top-3 left-3 bg-white">{p.bhk}</span>
      </div>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div>
          <h3 className="font-display font-bold text-xl leading-tight">{p.name}</h3>
          <p className="text-sm text-[#4A4A5A] mt-1">{p.location}, {p.area}</p>
        </div>
        <div className="flex items-center gap-4 text-xs text-[#4A4A5A]">
          <span className="inline-flex items-center gap-1"><Home size={14}/> {p.bhk}</span>
          <span className="inline-flex items-center gap-1"><Ruler size={14}/> {p.sqft} sq.ft.</span>
          <span className="inline-flex items-center gap-1"><Building2 size={14}/> {p.floor}</span>
        </div>
        <div className="mt-auto pt-3 border-t-2 border-dashed border-black/20 flex items-end justify-between">
          <div>
            <div className="text-xs uppercase tracking-widest text-[#4A4A5A]">{p.occupancy_type || "Rooms"} from</div>
            <div className="font-display font-extrabold text-2xl">{formatINR(p.price_from)}<span className="text-sm font-medium text-[#4A4A5A]">/month</span></div>
          </div>
          <span className="text-sm font-display font-bold underline decoration-2 underline-offset-4">View →</span>
        </div>
      </div>
    </Link>
  );
}
